export default __webpack_public_path__ + "static/media/instantECardUsagehelp@2x.6c4944b5.png";